import script from "./project-card.vue?vue&type=script&setup=true&lang=js"
export * from "./project-card.vue?vue&type=script&setup=true&lang=js"

import "./project-card.vue?vue&type=style&index=0&id=11674c7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11674c7e"]])

export default __exports__